/**
 * Kalıcı önbelleğin anahtarı tek yerde.
 *
 * İki yerde birden yazılıydı ve bu gerçek bir hataya yol açtı: çıkış yapınca
 * sunucudaki oturum kapanıyordu ama localStorage'daki kopya duruyordu, sayfa
 * yenilenince uygulama o kopyayla açılıp "hâlâ giriştesin" gibi görünüyordu.
 */
export const CACHE_KEY = 'kilo.cache.v1'

/** Oturum değiştiğinde çağrılıyor — bellekteki ve diskteki her şey gitsin. */
export function clearPersistedCache(): void {
  try { window.localStorage.removeItem(CACHE_KEY) } catch { /* özel mod */ }
}
